import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigService } from '@referrals/core/services';
import { OktaAuthTokenService } from '@referrals/core/services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private config: ConfigService,
    private oktaAuth: OktaAuthTokenService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    // Only add an access token to whitelisted origins
    // Needs thinking about for better sustainability
    const allowedOrigins = [
      `${this.config.referralsApiUrl}/sources`,
      `${this.config.referralsApiUrl}/sourcecategories`,
      `${this.config.referralsApiUrl}/sourceadvicecategories`,
      `${this.config.referralsApiUrl}/sourcelogs`,
      `${this.config.referralsApiUrl}/applicationaccess`,
      `${this.config.referralsApiUrl}/applicationconfig`,
    ];
    if (allowedOrigins.some((url) => request.urlWithParams.includes(url))) {
      const accessToken = await this.oktaAuth.AccessToken;
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken,
        },
      });
    }
    return next.handle(request).toPromise();
  }
}
